<style lang='scss' scoped>
@import './../assets/sass/colors';

.no-error-visible {
  display: none;
}

i.icon-header {
  font-size: 100px;
}

.banner {
  background-color: #fff4f4;
  font-size: 3rem;
  font-weight: 200;
  position: relative;

  .col:first-child {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .image {
    height: 500px;
    background: url('./../assets/img/partner-banner2.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  p span {
    color: $accent-primary-color;
  }
}

/* Extra Small Devices, Phones */ 
  @media only screen and (max-width : 480px) {
    .banner {
      font-size: 2.5em;
    }
  }

  .features {
    text-align: center;
    padding: 56px 0;
    background-color: white;
  }

  .form {
    // background-color: white;
  }

  .card-title {
    padding-bottom: 24px;
  }

  .buttons {
    text-align: right;
  }
</style>

<template lang='pug'>
  div(v-if='!submitted')
    .row.banner.no-margin
      .col.m6.hide-on-small-only.no-padding
        .container
          p.center-align 
            span Expand 
            | your business and 
            span go digital
            | .
      .image.col.s12.m6.offset-m6.no-padding
      .col.s12.hide-on-med-and-up
        .container
          p.center-align 
            span Expand 
            | your business and 
            span go digital
            | .
    .features.row
      .container
        p.center-align.subtitle.large Why partner with us?
        .vspace.large
        div.col.s12.m3
          .col.s10.offset-s1
            img.responsive-img(:src='"./../assets/img/icon-ecommerce.png"')
          p.subtitle.small.text-uppercase Sell Online
          p.subtitle.micro We have a robust system that makes uploading, editing, keeping track of inventory and deliveries very easy!
        .col.s12.vspace.large.hide-on-med-and-up
        div.col.s12.m3
          .col.s10.offset-s1
            img.responsive-img(:src='"./../assets/img/icon-customer-service.png"')
          p.subtitle.small.text-uppercase Customer Service
          p.subtitle.micro We have a customer service ready to assist and answer any of your queries.
        .col.s12.vspace.large.hide-on-med-and-up
        div.col.s12.m3
          .col.s10.offset-s1
            img.responsive-img(:src='"./../assets/img/icon-promotion.png"')
          p.subtitle.small.text-uppercase Leave the promotions to us
          p.subtitle.micro Our digital marketing team will keep producing content to make sure that your store keeps up with the latest market trend. 
        .col.s12.vspace.large.hide-on-med-and-up
        div.col.s12.m3
          .col.s10.offset-s1
            img.responsive-img(:src='"./../assets/img/icon-analytics.png"')
          p.subtitle.small.text-uppercase Analytics
          p.subtitle.micro We also have analytics as a premium service to allow you to identify market trend, demographics, and projections.
    .row.form
      .vspace.large
      .container
        .card
          .card-content
            .card-title.col.s12 Supplier Application
            .row
              .col.s12.m6.input-field(:class='{ "has-error": !hasSupplierName }')
                input#suppliername(type='text', placeholder='ex. inom ph' name='suppliername', v-model='name')
                label.active(for='suppliername') Business Name *
                span.red-text(:class='{ "no-error-visible": hasSupplierName }') Please provide your business name.
              .vspace.small
              .col.s12.m6.input-field(:class='{ "has-error": !hasSupplierAddress }')
                input#supplieraddress(type='text' placeholder='ex. Makati City' name='supplieraddress', v-model='address')
                label.active(for='supplieraddress') Business Address *
                span.red-text(:class='{ "no-error-visible": hasSupplierAddress }') Please provide your business address.
              .vspace.small
              .col.s12.m6.input-field(:class='{ "has-error": !isValidEmail }')
                input#supplieremail(type='email', placeholder='ex. name@domain.com' name='supplieremail', v-model='email')
                label.active(for='supplieremail') Business Email *
                span.red-text(:class='{ "no-error-visible": isValidEmail }') Empty or Invalid Email. Please modify the email provided.
              .vspace.small
              .col.s12.m6.input-field
                input#suppliercontact(type='text', placeholder='ex. 639991112233' name='suppliercontact', v-model='contactNumber')
                label.active(for='suppliercontact') Mobile Number
                span.red-text(:class='{ "no-error-visible": hasValidNumber }') Mobile number must follow the format 639XXXXXXXXX
              .vspace.small
              .col.s12.input-field(:class='{ "has-error": !hasDescription }')
                textarea.materialize-textarea(id='supplierdescription', v-model='description', placeholder='Tell us about your business')
                label.active(for='supplierdescription') Short Description *
                span.red-text(:class='{ "no-error-visible": hasDescription }') Please provide a description about your business.
              .col.s12.buttons
                a.btn#submitbutton(@click='submitApplication') Submit
    .vspace.small
  div(v-else)
    .row
      .vspace.large
      .col.s12.m8.l6.offset-m2.offset-l3
        .card.center-align
          .card-content
            div
              i.icon-header.material-icons.green-text check_circle
            .vspace.small
            p.title.large Thank you!
            .vspace.small
            p Your application has been submitted, we will contact you for further instructions
            p For inquiries, you may contact us at 
              span.text-emphasized +63 917 318 0286 
              | or through our email 
              a.text-emphasized(href='mailto:admin@inom.ph') admin@inom.ph
            .vspace.small

</template>
<script>
import validator from 'validator'
import axios from 'axios'

export default {
  meta: {
    title: 'Partner with Us'
  },
  data () {
    return {
      name: null,
      email: null,
      contactNumber: '',
      address: null,
      description: null,
      submitted: false
    }
  },
  computed: {
    hasSupplierName () {
      return this.name !== ''
    },
    hasSupplierAddress () {
      return this.address !== ''
    },
    isValidEmail () {
      if (this.email !== null) {
        return this.email !== '' && validator.isEmail(this.email)
      }
      return true
    },
    hasValidNumber () {
      return this.contactNumber && this.contactNumber.length === 12 && this.contactNumber.startsWith('639')
    },
    hasDescription () {
      return this.description !== ''
    },
    validForm () {
      return (
        this.hasSupplierName
        && this.hasSupplierAddress
        && this.isValidEmail
        && this.hasDescription
        && this.hasValidNumber
      )
    }
  },
  methods: {
    submitApplication () {
      axios
        .post(`${this.$config.API_URL}/suppliers/apply/`, {
          application: {
            name: this.name,
            email: this.email,
            contactNumber: this.contactNumber,
            address: this.address,
            description: this.description
          }
        })
        .then(data => {
          this.clearForm()
          this.submitted = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch(err => {
          this.$snackbar.show({
            text:
            'Oops, something went wrong while submitting your application.'
          })
        })
    },
    clearForm () {
      this.name = null
      this.email = null
      this.contactNumber = ''
      this.address = null
      this.description = null
    },
    attemptSubmitForm () {
      if (this.name === null) {
        this.name = ''
      }
      if (this.email === null) {
        this.email = ''
      }
      if (this.address === null) {
        this.address = ''
      }

      if (this.description === null) {
        this.description = ''
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/page-supplier-application.vue